const SESSION_STORE_KEY_AUTH = "Auth";
const SESSION_STORE_KEY_FINGERPRINT = "Fingerprint";

export function getGenericAuthModel(model) {
  return function () {
    let auth = sessionStorage.getItem(SESSION_STORE_KEY_AUTH);
    var authJson = null;

    if (auth != null) {
      authJson = JSON.parse(window.atob(auth));
    }

    if (authJson != null) {
      if (model == 'AUTH')
        return authJson;
      else
        return authJson[model];
    }

    return undefined;
  };
}

export function setGenericItemBtoa(key) {
  return function (value) {
    sessionStorage.setItem(key, btoa(JSON.stringify(value)));
  };
}

export function setUserPartner(value) {
  const auth = sessionStorage.getItem(SESSION_STORE_KEY_AUTH);
  if (auth) {
    let newAuth = JSON.parse(window.atob(auth));
    if (newAuth) {
      newAuth.UserPartner = value;
      sessionStorage.setItem(SESSION_STORE_KEY_AUTH, btoa(JSON.stringify(newAuth)));
    }
  }
}

export function removeAuth() {
  sessionStorage.removeItem(SESSION_STORE_KEY_AUTH);
}

export function getFingerprint() {
  let fingerprint = sessionStorage.getItem(SESSION_STORE_KEY_FINGERPRINT);
  if (fingerprint != undefined && fingerprint != null) {
    return window.atob(fingerprint);
  }
  return undefined;
}

export function getProfileCode() {
  let userPartner = getGenericAuthModel('UserPartner')();
  if (userPartner != null && userPartner != undefined)
    return userPartner.UserProfilePartner.Code;
  return "1";
}

export function getPartnerTypeCode() {
  let partner = getGenericAuthModel('Partner')();
  if (partner != null && partner != undefined)
    return partner.PartnerType.Code;
  return "1";
}

export function install(Vue) {
  Vue.prototype.$getAuth = getGenericAuthModel('AUTH');
  Vue.prototype.$getFingerprint = getFingerprint;
  Vue.prototype.$getTokenAuth = getGenericAuthModel('Token');
  Vue.prototype.$getUserPartner = getGenericAuthModel('UserPartner');
  Vue.prototype.$getPartner = getGenericAuthModel('Partner');
  Vue.prototype.$setAuth = setGenericItemBtoa(SESSION_STORE_KEY_AUTH);
  Vue.prototype.$setFingerprint = setGenericItemBtoa(SESSION_STORE_KEY_FINGERPRINT);
  Vue.prototype.$setUserPartner = setUserPartner;
  Vue.prototype.$removeAuth = removeAuth;
  Vue.prototype.$profileCode = getProfileCode;
  Vue.prototype.$partnerTypeCode = getPartnerTypeCode;
}

export default {
  install,
  getGenericAuthModel,
  removeAuth
};



// WEBPACK FOOTER //
// ./src/utils/sessionStoreAuth.js